import MuiTableCell from '@mui/material/TableCell';
import MuiTableRow from '@mui/material/TableRow';
import React from 'react';

export interface IColumn {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	cellRenderer?: (data: any, column: any) => any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getCellStyle?: (data: any) => any;
	hasSort?: boolean;
	label: string | React.ReactNode;
	maxWidth?: number;
	hideHeader?: boolean;
	name: string;
	width?: number;
	marginRight?: number;
}

interface ITableRow {
	columns: IColumn[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	row: any;
}

export const TableRow: React.FC<ITableRow> = ({ row, columns }) => (
	<MuiTableRow>
		{columns.map(
			({
				marginRight,
				name,
				cellRenderer,
				width,
				maxWidth,
				hideHeader,
				getCellStyle,
			}) => {
				const cellContent = cellRenderer
					? cellRenderer(row, { name })
					: row[name];
				return (
					<MuiTableCell
						padding={hideHeader ? 'checkbox' : 'normal'}
						key={name}
						style={getCellStyle ? getCellStyle(row) : undefined}
						className="table-cell"
					>
						<div
							style={{
								maxWidth: `${maxWidth}px` || undefined,
								width: (width && `${width}px`) || 'fit-content',
								marginRight: (marginRight && `${marginRight}px`) || 0,
							}}
						>
							{cellContent}
						</div>
					</MuiTableCell>
				);
			},
		)}
	</MuiTableRow>
);
